<template>
  <TTMGMSForm :script-id="scriptId" :interception="interception" />
</template>

<script setup>
/**
 * TTMGMSManualForm —>TTMGMSForm
 */
import TTMGMSForm from './TTMGMSForm.vue';

defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});
</script>
